module.exports = require("./../../_gen/starling/text/TextOptions");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/TextOptions.js
// module id = 231
// module chunks = 0